import { handleResponse } from "./handleResponse";

export const serverUrl =
  process.env.NODE_ENV === "production" ? "" : "https://localhost";

export default function fetchData(path: string, args: Object, isJson = true) {
  const headers = new Headers();
  let body: string | FormData;

  if (isJson) headers.set("Content-Type", "application/json");
  headers.set("Accept", "application/json");
  body = JSON.stringify(args);
  if (!isJson) {
    body = new FormData();
    Object.entries(args).forEach(([k, v]) => {
      (body as any).append(k, v);
    });
  }
  return fetch(`${serverUrl}/${path}`, {
    method: "POST",
    credentials: "include",
    headers,
    body,
  });
}

export function getData(path: string, params: any, isJson = true) {
  return fetchData(path, params, isJson)
    .then(handleResponse)
    .then((dto) => dto)
    .catch((error) => Promise.reject(error.message));
}
